import * as React from "react";
import { Grid, Heading } from "@chakra-ui/react";

import Card from "components/Chakra/Card";

const Registers: React.FunctionComponent = () => (
  <div id="rejstriky">
    <Heading as="h2" textAlign="center" mb={6} fontWeight="light">
      Prověřujeme v 5 českých a slovenských rejstřících
    </Heading>
    <Grid
      mt="18px"
      gap="18px"
      templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
    >
      <Card title="Centrální evidence exekucí ČR">
        Jde o veřejný seznam spravovaný Exekutorskou komorou České republiky.
        Věděli jste, že v Česku má každý 10. alespoň jednu exekuci?
      </Card>
      <Card title="Insolvenční rejstřík">
        Zaznamenává všechna probíhající i ukončená a dosud nevymazaná
        insolvenční řízení. Obsahuje seznam dlužníků a insolvenční spisy
        u jednotlivých řízení.
      </Card>
      <Card title="Úřední deska soudních exekutorů">
        Obsahuje dokumentaci k jednotlivým případům řízených exekucí, které si
        soudní exekutoři vedou na veřejných úředních deskách.
      </Card>
      <Card title="Osoby hledané Policií ČR">
        Seznam pohřešovaných a hledaných osob, po kterých Policie České
        republiky vyhlásila pátrání, ať už v současnosti nebo v minulosti.
      </Card>
      <Card title="Registr dlužníků na Slovensku">
        Uchovává záznamy vedených soudů na Slovensku v Obchodním věstníku
        a v Registru správců, od 31. července 2009.
      </Card>
    </Grid>
  </div>
);

export default Registers;
